// Third-party libraries
import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

export default function Modal({ show, onClose, title, children }) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" || e.keyCode === 27) {
        onClose();
      }
    };

    document.body.addEventListener("keydown", handleEscape);
    return () => {
      document.body.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);

  const renderDialogContent = () => {
    if (title === "Contact Us") {
      return (
        <div className="contact-us-jot-form">
          <iframe
            title="ContactUsForm"
            width="100%"
            height="500px"
            src="https://form.jotform.com/211792115518454"
          />
        </div>
      );
    }

    if (title === "Loose Diamond Memo Policy:") {
      const memoPolicies = [
        'Any single diamond priced at over $500 can be ordered on consignment for review ("on memo") in the US only.',
        "Customers are limited to not more than three diamonds on memo at any given time.",
        "Diamonds will be shipped on memo only upon request and subject to prior approval of the credit department. A credit card deposit may be required and will be at the sole discretion of Hoover & Strong.",
        "Diamonds on memo will not be shipped with the original certificate.",
        'Diamonds on memo must be shipped back within 5 business days of receipt. Diamonds must be shipped overnight or second day, in a box marked "attention department 291".',
        "Diamonds not received back within 7 business days will be billed to the customer and the original certificate will be sent to the customer.",
        "The customer is responsible for all shipping and handling charges.",
        "The acceptance of a return of a memo diamond after 7 business days and the fees involved will be at the sole discretion of Hoover & Strong.",
        "A $25.00 minimum charge will be applied to any account not returning diamonds on memo in their original packaging.",
      ];

      return (
        <List dense disablePadding>
          {memoPolicies.map((text, index) => (
            <ListItem key={index}>
              <ListItemText primary={`• ${text}`} />
            </ListItem>
          ))}
        </List>
      );
    }

    if (title === "Gemstone Memo Policy:") {
      const gemstonePolicies = [
        'Any single gemstone priced at over $500 can be ordered on consignment for review ("on memo").',
        "Gemstones will be shipped on memo only upon request and subject to prior approval of the credit department. A credit card deposit may be required and will be at the sole discretion of Hoover & Strong.",
        "Gemstones on memo will not be shipped with the original certificate (where applicable).",
        'Gemstones on memo must be shipped back within 5 business days of receipt. Gemstones must be returned overnight or second day, in a box marked "attention department 291".',
        "Overdue returns are subject to invoicing and fees at the discretion of Hoover & Strong.",
        "Gemstones not received back within 7 business days will be billed to the customer.",
        "The customer is responsible for all shipping and handling charges.",
        "The acceptance of a return of a memo gemstone after 7 business days and the fees involved will be at the sole discretion of Hoover & Strong.",
        "A $25.00 minimum charge will be applied to any account not returning Gemstones on memo in their original packaging.",
      ];

      return (
        <List dense disablePadding>
          {gemstonePolicies.map((text, index) => (
            <ListItem key={index}>
              <ListItemText primary={`• ${text}`} />
            </ListItem>
          ))}
        </List>
      );
    }

    return (
      <Typography gutterBottom sx={{ fontSize: "1.4rem" }}>
        {children}
      </Typography>
    );
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={show}
      maxWidth={title === "Contact Us" ? "xl" : "md"}
    >
      <DialogTitle
        id="customized-dialog-title"
        sx={{ fontSize: "1.6rem", fontWeight: "bold" }}
      >
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>{renderDialogContent()}</DialogContent>
    </Dialog>
  );
}
